import React from "react";
import moment from "moment";

const RelatorioProcedimentosOdontologicosContent = ({
  dadosRelatorio,
  filters,
}) => {
  const columnColor = (index) => {
    if (index % 2 !== 0) {
      return { backgroundColor: "#F2F2F2" };
    }
    return "";
  };

  const {
    dataInicio,
    dataFim,
    paciente,
    profissionalAtendimento,
    tipoAcao,
  } = filters || {};

  return (
    <>
      <div style={styles.titulo}>Relatório de Procedimentos Odontológicos</div>
      <div style={styles.subTitulo}>
        {dataInicio && (
          <div>
            Data início:
            <span>{moment(dataInicio).format("DD/MM/YYYY")}</span>
          </div>
        )}
        {dataFim && (
          <div>
            Data fim:
            <span>{moment(dataFim).format("DD/MM/YYYY")}</span>
          </div>
        )}
        {paciente && (
          <div>
            Paciente:
            <span>{paciente?.nome}</span>
          </div>
        )}
        {profissionalAtendimento && (
          <div>
            Profissional:
            <span>{profissionalAtendimento?.nome}</span>
          </div>
        )}
        {tipoAcao && tipoAcao !== "TODOS" && (
          <div>
            Status:
            <span>{tipoAcao === "REALIZADO" ? "Realizado" : "Finalizado"}</span>
          </div>
        )}
      </div>
      <div style={styles.headerColumn}>
        <div style={styles.columnData}>Data/Hora</div>
        <div style={styles.columnStatus}>Status</div>
        <div style={styles.columnPaciente}>Paciente</div>
        <div style={styles.columnProfissional}>Executante</div>
        <div style={styles.columnProcedimento}>Procedimento</div>
        <div style={styles.columnProfExecucao}>Realizado por</div>
        <div style={styles.columnDataExecucao}>Data realização</div>
      </div>
      <div>
        {dadosRelatorio && dadosRelatorio.length > 0 ? (
          dadosRelatorio.map((item, index) => {
            return (
              <div
                key={index}
                style={{ ...styles.containerColuna, ...columnColor(index) }}
              >
                <div style={styles.columnData}>
                  {item.dataHoraLancamento
                    ? moment(item.dataHoraLancamento).format("DD/MM/YYYY HH:mm")
                    : "-"}
                </div>
                <div style={styles.columnStatus}>
                  {item.status === "REALIZADO" ? "Realizado" : "Finalizado"}
                </div>
                <div style={styles.columnPaciente}>{item.pacienteNome || "-"}</div>
                <div style={styles.columnProfissional}>
                  {item.profissionalExecutanteNome || "-"}
                </div>
                <div style={styles.columnProcedimento}>
                  {item.procedimentoNome || "-"}
                </div>
                <div style={styles.columnProfExecucao}>
                  {item.profissionalExecucao || "-"}
                </div>
                <div style={styles.columnDataExecucao}>
                  {item.dataExecucao
                    ? moment(item.dataExecucao).format("DD/MM/YYYY HH:mm")
                    : "-"}
                </div>
              </div>
            );
          })
        ) : (
          <div style={styles.emptyMessage}>Nenhum dado disponível</div>
        )}
      </div>
    </>
  );
};

const styles = {
  titulo: {
    marginLeft: "0px",
    marginBottom: "10px",
    marginTop: "5px",
    paddingBottom: "5px",
    textAlign: "center",
    fontWeight: 700,
    fontSize: "16px",
  },
  subTitulo: {
    display: "flex",
    flexDirection: "row",
    borderBottom: "1px solid #505050",
    marginBottom: "15px",
    paddingBottom: "5px",
    fontWeight: 700,
    justifyContent: "center",
    gap: "8px",
    flexWrap: "wrap",
    fontSize: "12px",
  },
  headerColumn: {
    display: "flex",
    flexDirection: "row",
    fontWeight: 700,
    width: "100%",
    borderBottom: "2px solid #505050",
    paddingBottom: "5px",
    marginBottom: "5px",
    fontSize: "12px",
  },
  containerColuna: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    paddingBottom: "5px",
    paddingTop: "5px",
    fontSize: "11px",
  },
  columnData: {
    width: "13%",
  },
  columnStatus: {
    width: "10%",
  },
  columnPaciente: {
    width: "16%",
  },
  columnProfissional: {
    width: "16%",
  },
  columnProcedimento: {
    width: "16%",
  },
  columnProfExecucao: {
    width: "16%",
  },
  columnDataExecucao: {
    width: "13%",
  },
  emptyMessage: {
    textAlign: "center",
    padding: "20px",
    fontStyle: "italic",
    color: "#666",
  },
};

export default RelatorioProcedimentosOdontologicosContent;
